import { render, staticRenderFns } from "./WhatsappContact.vue?vue&type=template&id=07e4bb2e"
import script from "./WhatsappContact.vue?vue&type=script&lang=js"
export * from "./WhatsappContact.vue?vue&type=script&lang=js"
import style0 from "./WhatsappContact.vue?vue&type=style&index=0&id=07e4bb2e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports